/*
 * Copyright (c) 2026. Tooling Team
 */

import moment from "moment";
import { formatConceptDetailValue } from "./formatters";

const PREVIOUS_PREFIX = "previous";
const NEW_PREFIX = "new";

const HISTORY_FIELD_LABELS = {
  LoincCode: "LOINC Code",
  Status: "Status",
};

const toDisplayLabel = (fieldName) =>
  HISTORY_FIELD_LABELS[fieldName] ||
  fieldName
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/^./, (char) => char.toUpperCase());

const valuesAreDifferent = (previousValue, newValue) =>
  formatConceptDetailValue(previousValue) !==
  formatConceptDetailValue(newValue);

export const formatHistoryDate = (value) => {
  if (!value) return "Unknown date";

  const date = moment(value);
  if (!date.isValid()) return formatConceptDetailValue(value);

  return date.format("MM-DD-YYYY HH:mm:ss");
};

export const getHistoryChangesForRecord = (historyRecord) =>
  Object.keys(historyRecord || {})
    .filter((key) => key.startsWith(PREVIOUS_PREFIX))
    .map((previousKey) => {
      const fieldName = previousKey.slice(PREVIOUS_PREFIX.length);
      const newKey = `${NEW_PREFIX}${fieldName}`;

      if (!Object.prototype.hasOwnProperty.call(historyRecord, newKey)) {
        return null;
      }

      const previousValue = historyRecord[previousKey];
      const newValue = historyRecord[newKey];

      if (!valuesAreDifferent(previousValue, newValue)) {
        return null;
      }

      return {
        id: `${
          historyRecord._id || historyRecord.createdAt || previousKey
        }-${fieldName}`,
        field: fieldName,
        label: toDisplayLabel(fieldName),
        previousValue: formatConceptDetailValue(previousValue),
        newValue: formatConceptDetailValue(newValue),
        mapperId: formatConceptDetailValue(historyRecord.mapperId),
        createdAt: historyRecord.createdAt,
        createdAtDisplay: formatHistoryDate(historyRecord.createdAt),
      };
    })
    .filter(Boolean);

export const getMappingHistoryTimelineItems = (historyRecords = []) =>
  [...historyRecords]
    .sort((a, b) => {
      const aTime = new Date(a?.createdAt ?? 0).getTime();
      const bTime = new Date(b?.createdAt ?? 0).getTime();
      return (
        (Number.isFinite(aTime) ? aTime : 0) -
        (Number.isFinite(bTime) ? bTime : 0)
      );
    })
    .flatMap(getHistoryChangesForRecord);
